import { render, staticRenderFns } from "./weeks.vue?vue&type=template&id=a5d304ea&scoped=true"
import script from "./weeks.vue?vue&type=script&lang=js"
export * from "./weeks.vue?vue&type=script&lang=js"
import style0 from "./weeks.styl?vue&type=style&index=0&id=a5d304ea&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d304ea",
  null
  
)

export default component.exports